import { useNavigate, useParams } from "react-router-dom"
import { ObjectToParams } from "../utils"
import DatePicker from "react-datepicker"
import { Controller, useForm } from "react-hook-form"
import { useMemo } from "react"
import { useFetch } from "../hooks/useFetch"
import { getRoomsByHotel } from "../apis"

export default ({ hotel = {} }) => {
    const params = useParams()
    const navigate  = useNavigate()
    const { register, handleSubmit, control, getValues, watch, reset  } = useForm({ onChange: true })
    
    const [rooms] = useFetch(getRoomsByHotel, [], params.hotelId )
    const selectedRoom = watch("roomId")
    const selectedGuest = watch("guest") || 0

    const selectedRoomPrice = useMemo(() => rooms.find( r => r.id === selectedRoom )?.offerPrice, [ selectedRoom ])

    const submit = async ( data ) => {
        try {
            data.hotelId = params.hotelId
            // data.paymentMethod = "online"
            // data.paidAmount = 1
            // data.discountPrice = 0            
            navigate(`/confirm-pay?${ ObjectToParams(data)}`)
        } catch (error) {
            console.log("error", error)
            
        }
    }

    return (
        <form onSubmit={handleSubmit(submit)} className="card rounded-4 p-4 mt-5" >
            <div className="d-flex justify-content-between align-items-center">
                <div>
                    <p className="mb-1">Price</p>
                    <h5>From</h5>
                </div>
                <div>
                    <p className="mb-1">Non-Refundable</p>
                    <h5 className="text-saffron"><span className="text-muted text-decoration-line-through me-1 fs-8">₹{hotel.price}</span>₹{hotel.offerPrice}</h5>
                </div>
            </div>
            <hr />
            <div className="d-flex justify-content-between align-items-center">
                <div>
                    <p className="bold mb-0">Check In</p>
                    <Controller
                        name="checkInDate"
                        control={control}
                        rules={{ required: true }}
                        render={({ field }) =>
                            <DatePicker
                                {...field}
                                selected={getValues("checkInDate")}
                                placeholderText="Date"
                                className="input-2 border-bottom"
                                minDate={new Date()}
                                autoComplete={false}
                            />
                        }

                    />
                </div>
                <div>
                    <p className="bold mb-0">Check Out</p>
                    <Controller
                        name="checkOutDate"
                        control={control}
                        rules={{ required: true }}
                        render={({ field }) =>
                            <DatePicker
                                {...field}
                                selected={getValues("checkOutDate")}
                                placeholderText="Date"
                                className="input-2 border-bottom"
                                minDate={new Date()}
                                autoComplete={false}
                            />
                        }

                    />
                </div>
            </div>

            <label className="bold mt-2">Room</label>
            <select className="borderless"
            { ...register("roomId", { required: true })}
            >
                <option>Select Room</option>
                {
                    rooms?.map(( room, i ) => 
                        <option value={room?.id}>{ room?.roomCategoryId?.name }</option>
                    )
                }
            </select>
            <hr />

            <label className="bold">Guests</label>
            <select className="borderless"
                { ...register("guest", { required: true })}
            >
                <option>Select Guest</option>
                <option value={1}>1 guest</option>
                <option value={2}>2 guest</option>
                <option value={3}>3 guest</option>
            </select>
            <hr />

            <div className="d-flex justify-content-between align-items-center">
                <div>
                    <p className="mb-0"> ₹{ selectedRoomPrice || hotel.offerPrice } x { selectedGuest } per night</p>
                    <p className="bold">Total before taxes</p>
                </div>
                <div>
                    <p className="mb-0">₹{ (selectedRoomPrice * selectedGuest) || 0 }</p>
                    <p className="bold">₹{ (selectedRoomPrice * selectedGuest) || 0 }</p>
                </div>
            </div>
            <button type="submit" className="search-button mt-4 w-100">Book this Now</button>
        </form>
    )
}